import { includes } from "lodash";
import { useEffect } from "react";
import ReactGA from "react-ga4";
import { connect } from "react-redux";
import constants from "./constants";
import DataAdminDeals from "./DataAdminDeals";
import operations from "./ducks/operations";

const DataAdminDealsContainer = (props) => {
    useEffect(() => {
        ReactGA.send({ hitType: "pageview", page: "/deals", title: "Admin Deals" });
    }, []);

    return <DataAdminDeals {...props} />;
};

const mapStateToProps = (state) => {
    return {
        deals: state.dealsReducer.deals,
        dealView: includes(["data_admin_needs_final_review"], state.dealsReducer.dealView)
            ? state.dealsReducer.dealView
            : "data_admin_needs_final_review",
        isLoading: state.utilsReducer.isLoading,
        dealsPage: state.dealsReducer.dealsPage,
        dealsSort: state.dealsReducer.dealsSort,
        dealsFilter: state.dealsReducer.dealsFilter,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setDealsPage: (page) => {
            dispatch(operations.setDealsPage(page));
        },
        setDealsSort: (sort) => {
            dispatch(operations.setDealsSort(sort));
        },
        setDealsFilter: (filter) => {
            dispatch(operations.setDealsFilter(filter));
        },
        resetDealsTab: () => {
            dispatch(operations.resetDealsTab());
        },
        getDataAdminDeals: () => {
            dispatch(operations.getDeals(constants.urls.data_admin_needs_final_review(), "data_admin_needs_final_review"));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(DataAdminDealsContainer);
